module.exports = __webpack_public_path__ + "img/l-hd.b67363b6.webp";